import { getTypeValueByDataset } from '_legacy/components/grid/formatters/TypeFormatter';
import store from 'store';

export const TypeSortComparator = (a: string, b: string) => {
    const datasetId = store.getState().user?.group?.datasetId;
    if (
        getTypeValueByDataset(a, datasetId) ===
        getTypeValueByDataset(b, datasetId)
    )
        return 0;

    if (
        getTypeValueByDataset(a, datasetId) >
        getTypeValueByDataset(b, datasetId)
    )
        return -1;

    if (
        getTypeValueByDataset(a, datasetId) <
        getTypeValueByDataset(b, datasetId)
    )
        return 1;

    return 0;
};
